<template>
    <div v-bind="sliderSettings" v-if="sponsors.length">
        <a
            v-for="(sps, index) in sponsors"
            :key="index"
            :href="sps.href"
            class="sponsors__link"
        >
            <div class="sponsors__wrapper">
                <img
                    :src="localizedAsset(sps.img_path)"
                    :alt="sps.name"
                    class="sponsors__image"
                />
            </div>
        </a>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    props: {
        sponsorsArr: {
            type: Array
        }
    },
    name: "sponsors-slider",
    components: { VueSlickCarousel },
    data() {
        return {
            sliderSettings: {
                arrows: true,
                dots: false,
                focusOnSelect: true,
                slidesToShow: 2,
                rows: 2,
                vertical: true,
                verticalSwiping: true,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            rows: 1,
                            arrows: true,
                            dots: false,
                            vertical: false,
                            verticalSwiping: false,
                            adaptiveHeight: true
                        }
                    }
                ]
            },
            sponsors: []
        };
    },
    methods: {
        loadSponsors() {
            let that = this;
            console.log('Locale in vue: ' + window.APP_LOCALE)
            axios.post("/get-sponsors").then(function(res) {
                that.sponsors = [...res.data];
                that.sliderSettings.slidesToShow = that.sponsors.length;
            });
        },
        localizedAsset(path) {
            const base = window.APP_URL.replace(/\/+$/, '');        // clean trailing slashes
            const locale = window.APP_LOCALE;
            const formattedPath = path.replace(/^\/+/, '');          // clean leading slashes
            return `${base}/${formattedPath}`;
        }
    },
    mounted() {
        this.loadSponsors();
    }
};
</script>

<style scoped>
.sponsors__wrapper {
    height: 17rem;
    text-align: center;
    padding: 10px 20px;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.sponsors__image {
    width: auto;
    height: 85%;
    border-radius: 10px;
}
.sponsors__link {
    color: #45cc9c;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
}
</style>
